package com.essntl.features.supplier.ui.addeditsupplier

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.area.domain.model.AreaModel
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.proposal.domain.model.ProposalServiceModel
import com.essntl.features.service.domain.model.service.ServiceModel
import com.essntl.features.supplier.domain.model.SupplierModel

data class AddEditSupplierState(
    val supplier: MutableState<SupplierModel> = mutableStateOf(SupplierModel.empty),
    val getSupplier: State<SupplierModel> = State(),
    val addEditSupplier: State<SupplierModel> = State(),
    val getAllCategory: State<List<CategoryModel>> = State(),
    val getAllArea: State<List<AreaModel>> = State(),
    val getProposalServices: State<List<ProposalServiceModel>> = State(),
    val getItineraries: State<List<ItineraryModel>> = State(),
    val getAllService: State<List<ServiceModel>> = State(),
    val isEditEnabled: Boolean = false,
)
